import request from '@/utils/request'

// 订单 列表
export function getOrderListApi(page, size) {
  return request({
    url: `/order/list?page=${page}&size=${size}`,
    method: 'get'
  })
}
// 订单 详情
export function getOrderDetailApi(id) {
  return request({
    url: `/order/getOrderDetail?id=${id}`,
    method: 'get'
  })
}
// 订单 demo 支付状态
export function getDemoStatusApi(data) {
  return request({
    url: '/order/checkPayDemonResult',
    method: 'post',
    data
  })
}
// 订单 demo二维码
export function getDemoQrcodeApi(data) {
  return request({
    url: '/order/payYsDemon',
    method: 'post',
    data
  })
}
// 订单 创建
export function createtOrderApi(data) {
  return request({
    url: '/order/create',
    method: 'post',
    data
  })
}
// 订单 重新生成
export function againCreatetOrderApi(data) {
  return request({
    url: '/order/againCreate',
    method: 'post',
    data
  })
}
// 订单 删除
export function deleteOrderApi(data) {
  return request({
    url: '/order/del',
    method: 'post',
    data
  })
}
// 软著名称 生成
export function createTitleApi(data) {
  return request({
    url: '/title/createSelf',
    method: 'post',
    data
  })
}

// 套餐 列表
export function getPackageListApi() {
  return request({
    url: '/servicePackage/list',
    method: 'get'
  })
}
// 套餐 购买
export function payPackageApi(data) {
  return request({
    url: '/servicePackage/pay',
    method: 'post',
    data
  })
}
// 套餐 购买状态
export function payStatusApi(data) {
  return request({
    url: '/order/getPayStatus',
    method: 'post',
    data
  })
}